const STRIP_MONEY = /[$,\s]/g;

/**
 * Round to the nearest cent so float artifacts (e.g. 1500.9999999998) don't display as $1,500.99.
 */
export function roundMoneyToCents(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * 100) / 100;
}

/**
 * Normalize user/API money input to a two-decimal string for JSON payloads.
 */
export function parseMoneyToDecimalString(value: string | null | undefined): string | null {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const cleaned = String(value).replace(STRIP_MONEY, '').trim();
  const num = parseFloat(cleaned);
  if (isNaN(num)) return null;
  return roundMoneyToCents(num).toFixed(2);
}

/**
 * Format stored/API money values for UI (handles string decimals and float noise).
 */
export function formatUsd(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '$0.00';
  let n: number;
  if (typeof value === 'number') {
    n = roundMoneyToCents(value);
  } else {
    const cleaned = String(value).replace(STRIP_MONEY, '').trim();
    const parsed = parseFloat(cleaned);
    if (isNaN(parsed)) return '$0.00';
    n = roundMoneyToCents(parsed);
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}
